import { apiClient } from './axios'

/**
 *
 * @param {uuid} id
 * @returns {
 *   form_name: string,
 *   form_descriptor: json,
 *   fillable_from: date,
 *   fillable_to: date,
 * }
 */
export const getFormType = async (formName, section) => {
  try {
    return (await apiClient.get(`api/form-type/${formName}/${section}`)).data
      .results[0]
  } catch (err) {
    console.error('Hiba történt, kérem próbálkozzon újra')
    return false
  }
}

export const getTasks = async (competitionId) => {
  try {
    const response = await apiClient.get(
      `/api/competitions/${competitionId}/form_types`
    )
    return response.data
  } catch (error) {
    console.error('Error fetching form types:', error)
    throw error
  }
}

export const getCompetitionsUser = async () => {
  try {
    return (await apiClient.get(`api/competitions`)).data
  } catch (err) {
    console.error('Hiba történt, kérem próbálkozzon újra')
    return false
  }
}
